import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties.ts";
import type { SiteResponse } from "~types/site.ts";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect/InfinitySelect";

type Props = SelectBaseSingleProperties<InfinitySelectOption>;

export const SelectSite = ({ value, ...props }: Props) => {
  const { sport = "", organizationId = "" } = useParams();

  const onConvertResponseIntoOptionsHandler = (response: SiteResponse) =>
    (response?.data || []).map((site) => ({ label: site.nameLocal, value: site.siteId }));

  return (
    <InfinitySelect<SiteResponse>
      {...props}
      url={`${sport}/o/${organizationId}/sites`}
      sortByFieldName="nameLocal"
      searchParameter="nameLocalContains"
      queryClientPrefixKey={["sites", sport, organizationId]}
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.SITE}
      permissionOperation={PermissionOperations.READ}
    />
  );
};
